export const CHANNEL_NORI = 'NORI'
export const PRINTER_MODO_EPSON = 0
export const PRINTER_MODO_BROWSER = 1
export const PRINTER_MODO_ELECTRON = 2